import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "padding-bottom": "80px"
    }
  }, [_c('anchor', {
    staticStyle: {
      "left": "50px"
    },
    attrs: {
      "data": _vm.anchorList,
      "container": _vm.getContainer
    }
  }), _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #ddd",
      "padding-bottom": "10px",
      "margin-bottom": "20px"
    }
  }, [_c('a-breadcrumb', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    },
    attrs: {
      "separator": ""
    }
  }, [_c('a-breadcrumb-separator', [_c('span')]), _c('a-breadcrumb-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ProductListPage'
      }
    }
  }, [_vm._v(_vm._s(_vm.t('商品列表')))])], 1), _c('a-breadcrumb-separator', [_vm._v(">")]), _c('a-breadcrumb-item', [_vm._v(_vm._s(_vm.pageTitle))])], 1)], 1), _c('div', {
    staticStyle: {
      "padding": "0 200px 0 300px"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto"
    },
    attrs: {
      "data-sign": "packaging_add_edit_copy_form",
      "model": _vm.formData,
      "rules": _vm.formDataRule,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    staticClass: "flex-box block-box productBox"
  }, [_c('div', {
    staticClass: "form-item-title block-label",
    attrs: {
      "id": "packagingBaseMsg"
    }
  }, [_vm._v(_vm._s(_vm.t('基本信息')))]), _c('div', {
    staticClass: "block-content"
  }, [_vm.type === 'add' ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7C7B\u578B"),
      "label": _vm.t('商品类型'),
      "required": ""
    }
  }, [_c('a-radio-group', {
    attrs: {
      "value": _vm.$enum.product.ProductTypeMap.PACKAGING,
      "button-style": "solid"
    },
    on: {
      "change": _vm.handleProductTypeSwitchChange
    }
  }, _vm._l(_vm.productTypeEnum, function (item) {
    return _c('a-radio-button', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1) : _vm.customerInfo.is_product_packaging ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7C7B\u578B"),
      "prop": "basics_info.product_type",
      "label": _vm.t('商品类型')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "disabled": ""
    },
    model: {
      value: _vm.formData.basics_info.product_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "product_type", $$v);
      },
      expression: "formData.basics_info.product_type"
    }
  }, _vm._l(_vm.productTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801"),
      "prop": "basics_info.product_sku",
      "label": _vm.t('商品编码')
    }
  }, [_c('my-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.skuEditable,
      "max-length": 80,
      "placeholder": _vm.t('数字、字母、_、-、/、小数点、+、*、&以及英文括号')
    },
    model: {
      value: _vm.formData.basics_info.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "product_sku", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.basics_info.product_sku"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u53C2\u8003\u7F16\u7801"),
      "prop": "basics_info.reference_number",
      "label": _vm.t('参考编码')
    }
  }, [_c('my-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('数字、字母、_、-、/、小数点、+、*以及英文括号'),
      "max-length": 50
    },
    model: {
      value: _vm.formData.basics_info.reference_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "reference_number", $$v);
      },
      expression: "formData.basics_info.reference_number"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E2D\u6587\u540D\u79F0"),
      "prop": "basics_info.product_name_cn",
      "label": _vm.t('中文名称')
    }
  }, [_c('my-input', {
    attrs: {
      "max-length": 255
    },
    model: {
      value: _vm.formData.basics_info.product_name_cn,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "product_name_cn", $$v);
      },
      expression: "formData.basics_info.product_name_cn"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u82F1\u6587\u540D\u79F0"),
      "prop": "basics_info.product_name_en",
      "label": _vm.t('英文名称')
    }
  }, [_c('my-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('仅支持输入英文'),
      "max-length": 255
    },
    model: {
      value: _vm.formData.basics_info.product_name_en,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "product_name_en", $$v);
      },
      expression: "formData.basics_info.product_name_en"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u7C7B\u578B"),
      "prop": "basics_info.packaging_type",
      "label": _vm.t('包材类型')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    on: {
      "change": _vm.handlePackagingCategoryChange
    },
    model: {
      value: _vm.formData.basics_info.packaging_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "packaging_type", $$v);
      },
      expression: "formData.basics_info.packaging_type"
    }
  }, _vm._l(_vm.packagingCategoryEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u56FE\u7247"),
      "label": _vm.t('商品图片')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.imageTipMessage))]), _c('my-upload', {
    attrs: {
      "validate-type": "ProductImageRule",
      "data": _vm.formData.image_list,
      "checkError": _vm.onCheckError,
      "list-type": "picture-card",
      "before-upload": _vm.onImageBeforeUpload,
      "multiple": "",
      "file-list": _vm.imageList
    },
    on: {
      "onTipMessage": _vm.handleImageTipMessage
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.t('上传图片')))])], 1)], 1)], 1)]), _vm.isShowMapBarcode ? _c('div', {
    staticClass: "flex-box block-box productBox"
  }, [_c('div', {
    staticClass: "form-item-title block-label",
    attrs: {
      "id": "packagingMappingMsg"
    }
  }, [_vm._v(_vm._s(_vm.t('映射信息')))]), _c('div', {
    staticClass: "block-content"
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7B2C\u4E09\u65B9\u6761\u7801"),
      "label": _vm.t('第三方条码')
    }
  }, [_vm._l(_vm.formData.map_barcode_list, function (item, index) {
    return _c('a-form-model-item', {
      key: index,
      attrs: {
        "prop": "map_barcode_list." + index,
        "rules": _vm.formDataRule['map_barcode_list.*'],
        "label": _vm.t('')
      }
    }, [_vm.formData.map_barcode_list ? _c('div', {
      staticClass: "flex-box"
    }, [_c('div', {
      staticClass: "flex-item"
    }, [_c('my-input', {
      attrs: {
        "max-length": 50
      },
      on: {
        "input": function () {
          return _vm.handleMapBarcodeListInput(index);
        }
      },
      model: {
        value: _vm.formData.map_barcode_list[index],
        callback: function ($$v) {
          _vm.$set(_vm.formData.map_barcode_list, index, $$v);
        },
        expression: "formData.map_barcode_list[index]"
      }
    })], 1), _c('div', {
      staticClass: "barcode-tools"
    }, [_vm.formData.map_barcode_list.length < _vm.customerInfo.third_party_barcode_count ? _c('a', {
      attrs: {
        "href": "javascript:"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      on: {
        "click": function ($event) {
          return _vm.handleAddMapBarcodeList(index);
        }
      }
    })]) : _vm._e(), (_vm.formData.map_barcode_list.length || 0) > 1 ? _c('i', {
      staticClass: "fa fa-trash barcode-del-btn",
      on: {
        "click": function ($event) {
          return _vm.handleDeleteMapBarcodeList(index);
        }
      }
    }) : _vm._e()])]) : _vm._e()]);
  }), _c('common-tips', {
    attrs: {
      "isShowNumber": true,
      "data": [_vm.t('若实物未贴谷仓条码，需在此处填写实物上的条码。仓库会根据填写的第三方条码收货。错误的条码可能会影响您商品的入库，请谨慎填写；'), _vm.t('若实物未贴谷仓条码，且未填写第三方条码，可能导致入库异常并产生入库异常增值费；'), _vm.t('第三方条码仅支持数字、字母、_、-、/、小数点、+、*、&以及英文括号。商品审核通过后将无法修改，请谨慎填写；'), _vm.t('第三方条码不能重复使用。')]
    }
  })], 2)], 1)]) : _vm._e(), _c('div', {
    staticClass: "flex-box block-box productBox"
  }, [_c('div', {
    staticClass: "form-item-title block-label",
    attrs: {
      "id": "packagingSpecMsg"
    }
  }, [_vm._v(_vm._s(_vm.t('规格信息')))]), _c('div', {
    staticClass: "block-content"
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u644A\u5E73\u5C3A\u5BF8"),
      "label": _vm.t('商品摊平尺寸'),
      "required": ""
    }
  }, [_c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "spec_info.product_length"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('长'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.spec_info.product_length,
      callback: function ($$v) {
        _vm.$set(_vm.formData.spec_info, "product_length", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.spec_info.product_length"
    }
  }), _vm._v(" x ")], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "spec_info.product_width"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('宽'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.spec_info.product_width,
      callback: function ($$v) {
        _vm.$set(_vm.formData.spec_info, "product_width", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.spec_info.product_width"
    }
  }), _vm._v(" x ")], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "spec_info.product_height"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('高'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.spec_info.product_height,
      callback: function ($$v) {
        _vm.$set(_vm.formData.spec_info, "product_height", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.spec_info.product_height"
    }
  })], 1)], 1), _vm.isBox ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u6491\u5F00\u5C3A\u5BF8"),
      "label": _vm.t('商品撑开尺寸'),
      "required": ""
    }
  }, [_c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "basics_info.spread_length"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('长'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.basics_info.spread_length,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "spread_length", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.basics_info.spread_length"
    }
  }), _vm._v(" x ")], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "basics_info.spread_width"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('宽'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.basics_info.spread_width,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "spread_width", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.basics_info.spread_width"
    }
  }), _vm._v(" x ")], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "basics_info.spread_height"
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 30,
      "placeholder": _vm.t('高'),
      "addon-after": "CM"
    },
    model: {
      value: _vm.formData.basics_info.spread_height,
      callback: function ($$v) {
        _vm.$set(_vm.formData.basics_info, "spread_height", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.basics_info.spread_height"
    }
  })], 1)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u91CD\u91CF"),
      "prop": "spec_info.product_weight",
      "label": _vm.t('商品重量')
    }
  }, [_c('a-input', {
    staticClass: "inline-input",
    attrs: {
      "max-length": 30,
      "addon-after": "KG"
    },
    model: {
      value: _vm.formData.spec_info.product_weight,
      callback: function ($$v) {
        _vm.$set(_vm.formData.spec_info, "product_weight", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.spec_info.product_weight"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-box block-box productBox"
  }, [_c('div', {
    staticClass: "form-item-title block-label",
    attrs: {
      "id": "packagingCustomsMsg"
    }
  }, [_vm._v(_vm._s(_vm.t('进口海关信息')))]), _c('div', {
    staticClass: "block-content"
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "_import_country_list",
      "rules": _vm.formDataRule._import_country_list,
      "label": _vm.t('国家/地区')
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.t('国家/地区')) + " "), _c('a-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.t('下拉列表可选项与您的账号已开通的仓库关联的国家/地区有关。包材SKU的进口申报单价默认为0.01USD。')))]), _c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 2)], 1)]), _c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "mode": "multiple",
      "show-search": "",
      "maxTagCount": 3,
      "placeholder": _vm.t('请选择')
    },
    model: {
      value: _vm.formData._import_country_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "_import_country_list", $$v);
      },
      expression: "formData._import_country_list"
    }
  }, _vm._l(_vm.importCountryList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.country_code
      }
    }, [_vm._v(_vm._s(item.country_code) + "[" + _vm._s(item.country_name) + "]")]);
  }), 1)], 2)], 1)]), _c('div', {
    staticClass: "flex-box block-box productBox"
  }, [_c('div', {
    staticClass: "form-item-title block-label",
    attrs: {
      "id": "packagingOtherMsg"
    }
  }, [_vm._v(_vm._s(_vm.t('其他')))]), _c('div', {
    staticClass: "block-content"
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5907\u6CE8"),
      "label": _vm.t('备注')
    }
  }, [_c('a-input', {
    attrs: {
      "max-length": 500,
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: _vm.formData.other_info.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formData.other_info, "remark", $$v);
      },
      expression: "formData.other_info.remark"
    }
  })], 1)], 1)])])], 1), _c('footer-tool', [_c('a-button', {
    staticClass: "mr-10",
    attrs: {
      "data-permission": "packaging_add_cancel",
      "id": "packaging_add_cancel",
      "data-sign": "packaging_add_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'ProductListPage',
          params: {
            closeCurrent: '1'
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "packaging_add_submit",
      "id": "packaging_add_submit",
      "data-sign": "packaging_add_submit",
      "loading": _vm.addLoading,
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };